const PASSWORD = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-!@#$%&*()+=^.])[A-Za-z\d\-!@#$%&*()+=^.]{8,32}$/;
const EMAIL_REGEX = /^\s*[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\s*$/i;
const FIRST_NAME = /^(?!.*\..*\.)[a-zA-Z ]+$/; 
const USER_NAME = /^[A-Za-z0-9]+$/;

const regex = {
  PASSWORD,
  EMAIL_REGEX,
  FIRST_NAME,
  USER_NAME
};

export default regex;
